import { Dayjs } from 'dayjs';
import { usePlannerData } from 'hooks/usePlannerData';
import React from 'react';
import { BundleStatus } from 'types/bundleTypes';
import { OrderFilterOptionsType } from 'types/OrderFilterOptionsType';
import { Region } from 'types/orderTypes';
import { Error } from './components/Error';
import { Loading } from './components/Loading';
import './PlannerContainer.scss';
import { PlannerContainer } from './PlannerContainer';

interface PlannerWrapperProps {
  activeDate: Dayjs;
  region: Region;
  onDateChange: (newDate: string) => void;
}

export const PlannerWrapper = ({
  region,
  activeDate,
  ...props
}: PlannerWrapperProps) => {
  const plannerContainerRef = React.createRef<HTMLDivElement>();

  const plannerData = usePlannerData(region, activeDate);

  const onDateChange = (newDate: string) => {
    plannerData.reset();
    props.onDateChange(newDate);
  };

  return (
    <>
      <Loading
        loading={plannerData.loading}
        refetching={plannerData.refetching}
      />
      <Error error={plannerData.error} />
      {plannerData.done && (
        <>
          <PlannerContainer
            ref={plannerContainerRef}
            activeDate={activeDate}
            region={region}
            plannerData={plannerData}
            onDateChange={onDateChange}
          />
        </>
      )}
    </>
  );
};

export interface FilterType extends OrderFilterOptionsType {
  windows: string[];
  stores: string[];
  bundleStatus: BundleStatus[];
}
